// extracted by mini-css-extract-plugin
export default {"root":"Nh1xg","details":"NKy51","matchNamesWrapper":"hA6Mc","matchInfoWrapper":"t86tJ","rightCellWrapper":"er9ds","icon":"_eDO8"};